import React, {Component, Fragment} from 'react'
import Select from 'react-select'
import autobind from 'auto-bind'

import CustomSelectInput from 'components/CustomSelectInput'

import * as API from 'SDK/api'

export default class MultiCalendarDataModelPicker extends Component {
    id = 'MultiCalendarDataModelPicker'
    field = 'dataModelIds'
    constructor(props) {
        super(props)
        autobind(this)

        const initialValue =
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, 'existing') &&
            this.props.existing !== undefined
                ? this.props.existing
                : []

        this.state = {
            assets: [],
            selectedAssets: initialValue,
        }

        if (this.props && this.props.cb) {
            this.props.cb('dataModelIds', initialValue)
        }
    }

    getSelection() {
        return this.state.selectedAssets.map((o) => o.value)
    }
    handleAssetChange(selectedAssets) {
        this.setState({
            selectedAssets,
        })

        if (this.props.cb) {
            this.props.cb(
                'dataModelIds',
                selectedAssets.map((o) => o.value)
            )
        }
    }
    async getAssets() {
        let assets = await API.get('data-models', 2)
        if (!assets) return alert('Could not fetch data models.')

        assets = assets.filter(
            (a) => a.modelType === 'State' || a.modelType === 'Event'
        )
        let init = assets.map((x) => {
            return {label: x.name, value: x._id}
        })
        if (this.state.selectedAssets.length) {
            init = this.state.selectedAssets.map((x) => {
                const asset = assets.find((a) => a._id === x)
                return {
                    label: asset.name,
                    value: asset._id,
                }
            })
        }

        this.setState({assets, selectedAssets: init})

        if (this.props && this.props.cb) {
            this.props.cb(
                'dataModelIds',
                init.map((x) => x.value)
            )
        }
    }

    async componentWillMount() {
        await this.getAssets()
    }

    render() {
        return (
            <Fragment>
                <label>Data Model(s):</label>
                <Select
                    components={{Input: CustomSelectInput}}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="assets"
                    isMulti
                    value={this.state.selectedAssets}
                    onChange={this.handleAssetChange}
                    options={this.state.assets.map((a, i) => {
                        return {label: a.name, value: a._id, key: i}
                    })}
                />
            </Fragment>
        )
    }
}
